import React, { useEffect, useRef, useState } from "react";
import { PanelMachine } from "./StoryPanels";
import MobileStory from "./MobileStory";

// 2 pasos sobre la misma máquina fija: pirólisis (entradas/salidas) → agro (biochar y árboles)
const STEPS = ["tecnologia", "agro"];
const ANCHOR_VH = [0, 1.3];
const AGRO_AT_VH = 0.9;
const TOTAL_VH = 3.2;

const useDesktop = () => {
  const [d, setD] = useState(() => window.innerWidth >= 1024);
  useEffect(() => {
    const f = () => setD(window.innerWidth >= 1024);
    window.addEventListener("resize", f);
    return () => window.removeEventListener("resize", f);
  }, []);
  return d;
};

const Story = () => {
  const ref = useRef(null);
  const [progress, setProgress] = useState(0);
  const desktop = useDesktop();

  useEffect(() => {
    if (!desktop) return;
    const onScroll = () => {
      const el = ref.current;
      if (!el) return;
      const scrolled = -el.getBoundingClientRect().top;
      setProgress(Math.max(0, scrolled / window.innerHeight));
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [desktop]);

  if (!desktop) return <MobileStory />;

  const agro = progress >= AGRO_AT_VH;
  const active = agro ? 1 : 0;

  return (
    <section ref={ref} className="relative bg-2 border-t border-line" style={{ height: `${TOTAL_VH * 100}vh` }} data-testid="story-section" data-step={active}>
      {STEPS.map((id, i) => (
        <div key={id} id={id} className="absolute left-0 w-px h-px" style={{ top: `${ANCHOR_VH[i] * 100}vh` }} aria-hidden="true" />
      ))}
      <div className="sticky top-0 h-screen overflow-hidden">
        <div className="w-full h-full px-12 pt-[96px] pb-10 bg-2 flex items-center">
          <div className="max-w-6xl mx-auto w-full story-inner"><PanelMachine agro={agro} /></div>
        </div>
        <div className="absolute bottom-8 left-12 flex items-center gap-3" data-testid="story-progress">
          {STEPS.map((id, i) => (
            <span key={id} className={`h-px transition-all duration-300 ${i === active ? "w-14 bg-white" : "w-6 bg-white/30"}`} />
          ))}
          <span className="text-xs text-muted ml-2">0{active + 1} / 0{STEPS.length}</span>
        </div>
      </div>
    </section>
  );
};

export default Story;
